<main class="flex min-h-screen flex-col items-center justify-center gap-4 px-5 text-center font-raleway">
    <h1 class="text-4xl font-alice lg:text-6xl">Page introuvable</h1>
    <p>Cette page n'existe pas ou a été déplacée.</p>
    <a href="/" class="rounded-md bg-primary px-5 py-2.5 font-bold text-white hover:bg-secondary">Retour à l'accueil</a>
</main>
